import {approveCustomerOffer} from "@project/sdk/sales";
import {ApproveCustomerOfferResponse} from "@project/sdk/sales/zod";
import {mutationOptions} from "@tanstack/react-query";
import {customerOfferKeys, customerOfferMutationKeys} from "../../../customerOffer-keys";

export function approveCustomerOfferMutationOptions() {
  return mutationOptions({
    mutationKey: customerOfferMutationKeys.approveCustomerOffer,
    mutationFn: async (id: string) =>
      ApproveCustomerOfferResponse.parse(await approveCustomerOffer(id)),
    onSuccess: async (_result, ownerId, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: customerOfferKeys.detail(ownerId)}),
        client.invalidateQueries({queryKey: customerOfferKeys.lists()}),
      ]);
    },
  });
}
